import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkTable, SkAlertBanner } from './_primitives';

/** GamificationPage — optional alert, 4 stats, 3 tabs (Badges/Achievements/Leaderboard), table */
const GamificationPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <SkAlertBanner />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={3} />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default GamificationPageLoader;
